export default "__VITE_ASSET__Dh_VnotB__"